var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandCursorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65901",
    "data-name": "Group 65901",
    transform: "translate(15152 -8102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16418",
    "data-name": "Rectangle 16418",
    width: 25,
    height: 25,
    transform: "translate(-15152 8102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-raised-svgrepo-com",
    d: "M16.039,25.522c3.724,0,6.338-2.021,7.745-5.988L25.646,14.3a2.013,2.013,0,0,0-1.058-2.814,1.852,1.852,0,0,0-2.423,1.153l-.688,1.693a.113.113,0,0,1-.1.074c-.053,0-.074-.042-.074-.1V5.821a1.853,1.853,0,0,0-1.957-2.01,1.622,1.622,0,0,0-1.122.423,1.823,1.823,0,0,0-1.883-1.746,1.882,1.882,0,0,0-1.9,1.725,1.457,1.457,0,0,0-1.026-.4,1.774,1.774,0,0,0-1.83,1.936V6.921a1.6,1.6,0,0,0-1.164-.455,1.844,1.844,0,0,0-1.862,2v9.089C8.559,22.506,11.563,25.522,16.039,25.522Zm-.053-1.471c-3.745,0-6.031-2.4-6.031-6.666V8.614a.708.708,0,0,1,.73-.762.731.731,0,0,1,.751.762v5.407a.652.652,0,0,0,.656.656.666.666,0,0,0,.688-.656V5.937a.7.7,0,0,1,.719-.762.719.719,0,0,1,.751.762v7.544a.655.655,0,0,0,.667.656.666.666,0,0,0,.688-.656V4.626a.736.736,0,1,1,1.471,0v8.856a.655.655,0,0,0,.667.656.671.671,0,0,0,.677-.656V5.937a.741.741,0,1,1,1.481,0V16.349a.764.764,0,0,0,.751.836.986.986,0,0,0,.942-.7l1.439-3.216A.764.764,0,0,1,24,12.73c.423.169.571.571.37,1.122l-1.873,5.227C21.2,22.686,18.938,24.051,15.986,24.051Z",
    transform: "translate(-15156.559 8100.512)",
    fill: "#102633"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCursorIcon);
export default __webpack_public_path__ + "static/media/handCursorIcon.6b78295f0fc922f61b29f39466dfe724.svg";
export { ForwardRef as ReactComponent };